import {
  GET_SPECIALTY_LIST_REQUESTED,
  GET_AREA_OF_FOCUS_REQUESTED,
  GET_LOCATION_REQUESTED,
  FIND_PROVIDERS_REQUESTED,
  BACK_TO_SEARCH,
  GET_PROVIDER_SEARCH,
  EMPTY_PROVIDER_SEARCH,
  CLEAN_PROVIDER_SEARCH_ERROR,
  CLEAN_AREA_OF_FOCUS,
  PROVIDER_SELECTION_LIMIT_REACHED,
  PROVIDER_SELECTION_LIMIT_REACHED_REMOVE,
  SEARCH_FOR_PROVIDER_ERRORS,
  TOGGLE_NEIGHBORHOOD_PROVIDER_FLAG,
} from '../constants/constant.action'

export function getSpecialtyList(reqObj) {
  return {
    type: GET_SPECIALTY_LIST_REQUESTED,
    payload: reqObj,
  }
}

export function getAreaOfFocus(reqObj) {
  return {
    type: GET_AREA_OF_FOCUS_REQUESTED,
    payload: reqObj,
  }
}

export function getLocation() {
  return {
    type: GET_LOCATION_REQUESTED,
    payload: {},
  }
}

export function findProviders(reqObj) {
  return {
    type: FIND_PROVIDERS_REQUESTED,
    payload: reqObj,
  }
}

export function backToSearch() {
  return {
    type: BACK_TO_SEARCH,
  }
}

export function getProviderSearch(value) {
  return {
    type: GET_PROVIDER_SEARCH,
    payload: value,
  }
}

export function emptyProviderSearch() {
  return {
    type: EMPTY_PROVIDER_SEARCH,
  }
}

export function cleanProviderSearchError() {
  return {
    type: CLEAN_PROVIDER_SEARCH_ERROR,
  }
}

export function cleanAreaOfFocus() {
  return {
    type: CLEAN_AREA_OF_FOCUS,
  }
}

export function providerSelectedLimit(payload) {
  return {
    type: PROVIDER_SELECTION_LIMIT_REACHED,
    payload,
  }
}

export function providerSelectedLimitRemove() {
  return {
    type: PROVIDER_SELECTION_LIMIT_REACHED_REMOVE,
  }
}

export function searchForProviderError() {
  return {
    type: SEARCH_FOR_PROVIDER_ERRORS,
    payload: null,
  }
}

export function toggleNeighborhood() {
  return {
    type: TOGGLE_NEIGHBORHOOD_PROVIDER_FLAG,
  }
}
